import React from 'react'
import Box from '@material-ui/core/Box'
import CloseIcon from '@material-ui/icons/Close'
import DialogContent from '@material-ui/core/DialogContent'
import MuiDialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'
import ReactMarkdown from 'react-markdown'
const Dialog = ({
  title,
  heading,
  text,
  children,
  open,
  onClose,
  headingSecondary,
  textSecondary,
}) => (
  <MuiDialog fullWidth open={open} onClose={onClose}>
    <Box py={4} px={2}>
      <Box align="right" pr={2}>
        <CloseIcon
          onClick={onClose}
          style={{ fontSize: '32px', cursor: 'pointer' }}
        />
      </Box>
      <DialogContent>
        {title && (
          <Box mb={2}>
            <Typography variant="h2">{title}</Typography>
          </Box>
        )}
        <Box mb={2}>
          <Typography variant="h4">{heading}</Typography>
        </Box>
        {text ? (
          <Typography variant="body1">
            <ReactMarkdown
              components={{
                p: ({ children }) => (
                  <p style={{ margin: '0 0 16px 0' }}>{children}</p>
                ),
              }}
            >
              {text.replace(/\n/g, '  \n')}
            </ReactMarkdown>
          </Typography>
        ) : (
          children
        )}
        {headingSecondary && textSecondary ? (
          <Box mt={4}>
            <Box mb={2}>
              <Typography variant="h4">{headingSecondary}</Typography>
            </Box>
            <Typography variant="body1">{textSecondary}</Typography>
          </Box>
        ) : null}
      </DialogContent>
    </Box>
  </MuiDialog>
)

export default Dialog
